import { render, staticRenderFns } from "./DeptHelplist.vue?vue&type=template&id=af2f74c2&"
import script from "./DeptHelplist.vue?vue&type=script&lang=js&"
export * from "./DeptHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports